// A stalled/dropped connection doesn't always make fetch() reject on its own —
// without an explicit timeout, a hung request just never resolves, leaving
// whatever loading UI is watching it stuck forever with no error shown.
export const DEFAULT_FETCH_TIMEOUT_MS = 20000;

// Pass 0 (or any non-finite value) to opt a call out of the timeout entirely.
export function fetchWithTimeout(
  url: string,
  options: RequestInit = {},
  timeoutMs: number = DEFAULT_FETCH_TIMEOUT_MS,
): Promise<Response> {
  if (!Number.isFinite(timeoutMs) || timeoutMs <= 0) {
    return fetch(url, options);
  }
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
  return fetch(url, { ...options, signal: controller.signal }).finally(() =>
    clearTimeout(timeoutId),
  );
}
